import React from 'react';
import { formatGtmAction } from '@hpi-sox/hpstellar-utils';
import { Link } from '@hpi-sox/hpstellar-core/visId';
import { Typography, RadioCard, ColorSelection } from '@hpi-sox/hpstellar-core/visId';

import AdaptiveImage from '../../shared/components/adaptive-image';
import { Helpers } from '../../core/src/helpers';
import useInpChecked from '../../hooks/useInpChecked';

import './radio-button-card.less';

function RadioButtonCard({
    infoClassName,
    ariaLabel,
    label,
    title,
    info,
    colorHex,
    imageUrl,
    value,
    error,
    offerMessage,
    content,
    onChange,
    productName,
    to,
    linkText = 'View Details',
    gtmActions,
    checked,
    isInpOptimized,
    colorSwatchProps,
    groupName,
    className = '',
    style = {},
    ...rest
}) {
    const alt = productName ? `${productName}${label ? ' - ' + label : ''}` : '';
    const inpCheckedData = useInpChecked(value, checked, !isInpOptimized);
    const { derivedCheck, setInpChecked } = inpCheckedData || {};

    const onChangeHandler = e => {
        try {
            if (!isInpOptimized) {
                onChange(value);
            } else {
                if (typeof setInpChecked === 'function') {
                    setInpChecked(!checked);
                }
                setTimeout(() => {
                    onChange(value);
                }, 0);
            }
        } catch (e) {}
    };
    const isChecked = isInpOptimized ? derivedCheck : checked;

    return (
        <RadioCard
            {...rest}
            className={`radio-container-v2 ${className}`.trim()}
            inputProps={{
                checked: isChecked,
                name: groupName,
                'aria-label': ariaLabel || label,
                value,
                onChange: onChangeHandler,
                ...formatGtmAction(gtmActions, 'radioClick'),
            }}
            style={{
                flexDirection: 'column',
                gap: 8,
                ...style,
            }}
        >
            <div className="radio-left-container">
                <div className="radio-left">
                    {imageUrl && <AdaptiveImage src={imageUrl} desktopWidth={80} alt={alt} />}
                    <div className="radio-label">
                        {title && <b className="radio-title">{title}</b>}
                        <div className="radio-title">
                            {colorHex && (
                                <ColorSelection
                                    className={`color-swatch ${colorSwatchProps?.shape === 'square' ? 'square' : ''}`}
                                    colors={[{ color: colorHex }]}
                                    isPreview={true}
                                />
                            )}
                            <Typography variant="body1">{label}</Typography>
                        </div>
                        {offerMessage && (
                            <div
                                className="offer-message"
                                dangerouslySetInnerHTML={Helpers.createMarkup(offerMessage)}
                            />
                        )}
                        {to && (
                            <Link
                                aria-label={linkText}
                                target="_blank"
                                dense
                                to={to}
                                variation="body"
                                onClick={e => {
                                    e.stopPropagation();
                                }}
                            >
                                {linkText}
                            </Link>
                        )}
                    </div>
                </div>
                {info && (
                    <Typography
                        variant="body1"
                        weight={700}
                        className={`radio-info${infoClassName ? ` ${infoClassName}` : ''}`}
                    >
                        {info}
                    </Typography>
                )}
            </div>
            {content && <div className="radio-custom">{content}</div>}
            {error && <div className="radio-error-message">{error}</div>}
        </RadioCard>
    );
}

export default React.memo(RadioButtonCard);
